var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignupKrsenjePrincipa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-8{fill:none;}.cls-1,.cls-5{stroke:#6e5dd8;}.cls-1,.cls-5,.cls-8{stroke-miterlimit:10;}.cls-1,.cls-5,.cls-7,.cls-8{stroke-width:1.5px;}.cls-2,.cls-7{fill:#fa7268;}.cls-3{fill:#aa6276;}.cls-4{fill:#6e5dd8;}.cls-5{fill:#fff;}.cls-6{fill:#159497;}.cls-7{stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;}.cls-8{stroke:#fa7268;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.06,37.9c-29,6.21-59.9,16.28-86,30.47-55,29.88-73.47,94.11-32.35,144.71C105,241.7,140,258.24,175.12,269.32c93.7,29.51,201.19,25.68,290.3-17,15.81-7.58,31.19-16.47,44-28.41s23.08-27.17,26.9-44.28c3.63-16.3,1.22-33.72-5.8-48.86-9.83-21.2-28-37.48-47.74-50-90.39-57.4-219.74-59.23-315.65-15.47"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 531.36,
    cy: 51.85,
    r: 8.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 362.9,
    y: 232.99,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "188.25 84.68 181.94 95.59 194.55 95.59 188.25 84.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320.77,210c2.56-.52,18.74-3,30.25-4.81a49.37,49.37,0,0,0,28.24-14.81l.15-.16a51.77,51.77,0,0,0,5-6.33L393,164.4c.54-1.94,1-3.89,1.45-5.86,0-.22.11-.42.17-.62V116.2L324.2,103l-25.91,3.45c-7.56,1-15.16,2-22.44,4.28-25.13,7.78-43.43,29.16-58.55,50.69s-29.11,44.81-50.61,60c7.52,22.15,31.9,40.06,53.47,46.46a4.66,4.66,0,0,0,2.6.24,4.77,4.77,0,0,0,1.83-1.3C250.55,241.31,310.32,212.06,320.77,210Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 326.02,
    y: 26.99,
    width: 141.15,
    height: 169.08,
    rx: 16.91
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "132.83 236.43 162.84 213.35 231.69 272.03 205.3 298.01 132.83 236.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M396.59,65.22a46.31,46.31,0,1,0,46.32,46.31A46.36,46.36,0,0,0,396.59,65.22Zm34.26,46.31a34,34,0,0,1-6.16,19.56l-19.57-19.56L424.69,92A34.05,34.05,0,0,1,430.85,111.53Zm-14.69-28.1L396.59,103,377,83.44a34.13,34.13,0,0,1,39.13,0Zm-53.82,28.1A34.05,34.05,0,0,1,368.5,92l19.57,19.57L368.5,131.09A34,34,0,0,1,362.34,111.53ZM377,139.62l19.56-19.57,19.57,19.57a34.15,34.15,0,0,1-39.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M283.64,135.73c10.83-5.68,23.09-5.33,34.82-7.11A99,99,0,0,0,351.86,117c4.62-2.58,10.52-5.39,14.34-1.38s2.21,11.29-.71,16.08c-4.75,7.78-12.08,12.65-19.18,17.27l-41.56,27.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.08,32.84C82.41,43.16,67.74,55.45,57.16,70.94S40.34,105.4,42.49,124,56,160.6,73.17,168.18c20.43,9,45.14,2.08,62.64-11.79,5.61-4.45,11.15-11,9.41-18-1.55-6.18-8.64-9.69-15-9.17s-12,4.1-17.11,7.93c-43.78,32.89-64.05,94-48.62,146.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M490,270.75a32.38,32.38,0,0,1,61.59,1.41"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupKrsenjePrincipa);
export default __webpack_public_path__ + "static/media/Signup-krsenje_principa.511dcb5039a04d8df83844aae593e191.svg";
export { ForwardRef as ReactComponent };